import React, { useEffect, useState } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { useCommonJobProvider } from "../../../../../Providers/Common/Jobs";
import Back from "../../../../../Components/Back";
import CustomTable from "../../../../../Components/Table";
import OngoingJobInformation from "../OngoingJobInformation";
import { useNavigate } from "react-router-dom";

const headCells = ["Job Title", "Start Date", "Consultant", "Status"].map(
  (label) => ({ label })
);
export default function Jobs({ setCard }) {
  const { allJobs, fetchAllJobs } = useCommonJobProvider();
  const [jobId, setJobId] = useState()
  useEffect(() => {
    fetchAllJobs();
  }, []);
  const navigate = useNavigate()

  const CustomRow = ({ row }) => {
    return (
      <TableRow onClick={() => {
        navigate(`/dashboard/jobscard/${row?.job?.id}`)
      }} hover tabIndex={-1} key={row?.id} className="cursor-pointer">
        <TableCell component="th" scope="row">
          {row?.job?.name}
        </TableCell>
        <TableCell align="left">{row?.job?.start_date}</TableCell>
        <TableCell align="left">
          {row?.consultant_id === null
            ? "Not Assigned"
            : `${row?.consultant?.firstName} ${row?.consultant?.lastName}`.trim()}
        </TableCell>
        <TableCell align="left">{row?.job?.status}</TableCell>
      </TableRow>
    );
  };

  return (
    <>
      {jobId ? <OngoingJobInformation jobId={jobId} reset={() => setJobId()} /> : <>
        <Back onClick={() => {
          navigate("/dashboard")
        }} />
        <CustomTable
          title="Jobs"
          headCells={headCells}
          rows={allJobs}
          CustomRow={CustomRow}
        />
      </>}
    </>
  );
}
